// extracted by mini-css-extract-plugin
export default {"addToCartControl":"qY-z","giftCard":"rY-z","btnContainer":"sY-z","cartButton":"tY-z","disabled":"uY-z"};